import { type PricingServiceProductSubscriptionContainer } from '@hungryroot/rest';

export function getCustomerProductSubscriptionCopy(
  containerId: number,
  customerProductSubscriptionContainers?: Record<
    number,
    PricingServiceProductSubscriptionContainer
  >
) {
  if (
    customerProductSubscriptionContainers === undefined ||
    customerProductSubscriptionContainers[containerId] === undefined
  ) {
    return 'None';
  }
  return customerProductSubscriptionContainers[containerId].elements
    .map((element) => element.product.name)
    .join(', ');
}
